import React from 'react';
import { Pressable } from 'react-native';
import { Marker } from 'react-map-gl/maplibre';

import CloudStationIcon from './icons/CloudStationIcon';
import { strings } from '../strings';
import type { Station } from '../types/station';
import { getStationAccessibilityLabel } from '../utils/aqi';

type StationMarkerProps = {
  station: Station;
  onPress: (station: Station) => void;
};

const StationMarker = ({ station, onPress }: StationMarkerProps) => {
  return (
    <Marker
      longitude={station.longitude}
      latitude={station.latitude}
      anchor="center"
      onClick={event => {
        // Prevent the click from reaching the map canvas, which would trigger
        // Map's onClick and immediately deselect the station.
        (
          event.originalEvent as unknown as { stopPropagation: () => void }
        ).stopPropagation();
        onPress(station);
      }}
    >
      {/* A Pressable (instead of a pointer-events:none View) turns the marker
          into a real button that keyboard users can focus and activate with
          Enter/Space, and gives screen readers a name, city and AQI to read. */}
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={getStationAccessibilityLabel(station)}
        accessibilityHint={strings.stationMarkerHint}
        onPress={() => onPress(station)}
      >
        <CloudStationIcon station={station} />
      </Pressable>
    </Marker>
  );
};

export default StationMarker;
